<template>

  <div v-if="menus && menus.length" >
    <ul class="nav mb-4" >
      <div v-for="menu of menus" v-bind:key="menu.ba06_id">
        <div v-if="menu.ba06_sistema_id == sistema_id && menu.ba06_pai_id == menu_cadastro_id">
          <li class="nav-item"><router-link :to="menu.ba06_url" class="mr-1 p-2 nav-link">{{menu.ba06_nome}}</router-link></li>
        </div>
      </div>
    </ul>
  </div>

</template>

<script>

export default {
  name: 'MenuInternoCadastros',
  data () {
    return {
      menus: '',
      sistema_id: API.sistema_id,
      menu_cadastro_id: API.menu_cadastro_id
    }
  },
  mounted () {
      API.enviarRequisicao('get', '/api/controleacesso/menus?filters=position::ord(asc)')
      .then(response => (this.menus = response.data))
  }
}
</script>

<style scoped>

a {
  background-color: #18A689;
  color: #fff;
  font-size: 12px;
  text-decoration: none;
}
a:hover {
  background-color: #fff;
  color: #2c2c2c;
}

.router-link-exact-active {
  background-color: #fff;
  color: #000;
}

a:focus {
  box-shadow: 0 0 0 0;
  border: 0 none;
  outline: 0;
}

</style>
